import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getInfrastructurePhotos: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTOS,
	},
	createInfrastructurePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].CREATE_PHOTO,
	},
	getInfrastructurePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTO,
	},
	patchInfrastructurePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PATCH_PHOTO,
	},
	putInfrastructurePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PUT_PHOTO,
	},
	deleteInfrastructurePhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].DELETE_PHOTO,
	},
}